const d3 = Object.assign({},
    require('d3-transition'),
    require('d3-selection'),
    require('d3-selection-multi')
);

export class ChartBaseTooltip {
    constructor (tooltipClass) {
        if (!tooltipClass) {
            tooltipClass = 'chart-tooltip';
        }
        this.tooltip = d3.select(`.${tooltipClass}`);
        if (this.tooltip.empty()) {
            this.tooltip = d3.select('body').append('div')
                .attr('class', tooltipClass)
                .style('display', 'none')
                .style('opacity', 0);
        }
    }

    displayTooltip (content, event) {
        this.tooltip
            .style('display', 'block')
            .transition().duration(100)
            .style('opacity', 1);
        this.tooltip.html(content);
        this.tooltip
            .style('left', `${Math.max(0, event.pageX - 5 - this.tooltip.node().clientWidth)}px`)
            .style('top', `${Math.max(0, event.pageY - 13 - this.tooltip.node().clientHeight)}px`);
    }

    hideTooltip () {
        this.tooltip
            .transition().duration(100)
            .style('opacity', 0);
    }
}
